module.exports = __webpack_public_path__ + "img/clint-mckoy.36f95307.jpg";